module.exports = __webpack_public_path__ + "static/media/BWIN.f96d00f1.svg";